import script from "./AgreementCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./AgreementCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./AgreementCheckbox.vue?vue&type=style&index=0&id=6e4c00bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e4c00bd"]])

export default __exports__